var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'options-button': true,
    'enabled': !_vm.disabled,
    'type-install-button': _vm.typeInstall,
    'full-width': _vm.fullWidth,
    },on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.typeInstall)?_c('div',{staticClass:"options-button__image-side"},[_c('div',{staticClass:"options-button__img-bg",style:({
          'background-image': ("url('" + _vm.img + "')"),
        })}),_c('div',{staticClass:"options-button__halftone-bg",style:({
          'background-image': ("url('" + (require('../../../assets/images/mainButtons/halftone-bg.png')) + "')"),
        })})]):_vm._e(),_c('div',{staticClass:"options-button__text-side"},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.icon !== '')?_c('img',{attrs:{"src":_vm.icon}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }